import { defaultExclusionCheck } from '@/composables/exclusion-checks';

export function useGoalExclusionCheck() {
  const shouldExclude = (entity, context) => defaultExclusionCheck(entity, context);

  return { shouldExclude };
}
